export default __webpack_public_path__ + "static/media/before_sponsor.cdeccd13.webp";